(function () {
  'use strict';

  var drawer = null;
  var config = {
    moneySymbol: '£',
    moneyLocale: 'en-GB',
    cartUrl: '/cart',
    checkoutUrl: '/checkout',
    dealerPrices: {}
  };

  function loadConfig() {
    var el = document.getElementById('eride-cart-config');
    if (!el) return;
    try {
      Object.assign(config, JSON.parse(el.textContent));
    } catch (e) {}
  }

  function formatMoney(cents) {
    return config.moneySymbol + (cents / 100).toLocaleString(config.moneyLocale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getDealerUnitExMinor(item) {
    if (!item) return null;
    var props = item.properties || {};
    var raw = props._unit_price_ex_vat || props['_unit_price_ex_vat'];
    if (raw) {
      var parsed = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
      if (parsed > 0) return Math.round(parsed * 100);
    }
    var handle = item.handle;
    if (handle && config.dealerPrices && config.dealerPrices[handle]) {
      return config.dealerPrices[handle];
    }
    return null;
  }

  function getLineDisplayMinor(item) {
    var dealerUnit = getDealerUnitExMinor(item);
    if (dealerUnit != null) {
      return dealerUnit * item.quantity;
    }
    return item.final_line_price;
  }

  function getCartSubtotalMinor(cart) {
    if (!cart || !cart.items || !cart.items.length) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + getLineDisplayMinor(item);
    }, 0);
  }

  function getDrawer() {
    if (!drawer) drawer = document.getElementById('eride-cart-drawer');
    return drawer;
  }

  function tierLabel(props) {
    if (!props) return '';
    var tier = props._pricing_tier || props['_pricing_tier'];
    if (tier === 'dealer') return 'Dealer price';
    if (tier === 'tier2') return 'Dealer price';
    if (tier === 'tier1') return 'Dealer price';
    return '';
  }

  function getItemMinQty(item) {
    if (!item || !item.properties) return 1;
    var props = item.properties;
    var minProp = props._min_qty || props['_min_qty'];
    if (minProp) {
      var parsed = parseInt(minProp, 10);
      if (parsed > 0) return parsed;
    }
    if (props._is_vehicle === 'true' || props['_is_vehicle'] === 'true') return 1;
    if (props._pricing_tier || props['_pricing_tier']) return 1;
    return 1;
  }

  function renderItem(item) {
    var li = document.createElement('li');
    li.className = 'eride-cart-drawer__item';
    li.dataset.lineKey = item.key;
    li.dataset.minQty = String(getItemMinQty(item));

    var imageSrc = item.image ? item.image.replace(/(\._[^.]+_)?\.(jpg|jpeg|png|webp)/i, '_120x.$2') : '';
    var tier = tierLabel(item.properties);
    var meta = tier ? '<span class="eride-cart-drawer__item-tier">' + tier + '</span>' : '';
    var minQty = getItemMinQty(item);
    var minusDisabled = item.quantity <= minQty ? ' disabled' : '';

    li.innerHTML =
      '<div class="eride-cart-drawer__item-media">' +
        (imageSrc ? '<img src="' + imageSrc + '" alt="" width="80" height="80" loading="lazy">' : '') +
      '</div>' +
      '<div class="eride-cart-drawer__item-main">' +
        '<a href="' + item.url + '" class="eride-cart-drawer__item-title">' + item.product_title + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="eride-cart-drawer__item-variant">' + item.variant_title + '</span>'
          : '') +
        meta +
        '<div class="eride-cart-drawer__item-row">' +
          '<div class="eride-cart-drawer__qty">' +
            '<button type="button" class="eride-cart-drawer__qty-btn" data-qty-change="-1" aria-label="Decrease quantity"' + minusDisabled + '>−</button>' +
            '<span class="eride-cart-drawer__qty-val" data-qty-display>' + item.quantity + '</span>' +
            '<button type="button" class="eride-cart-drawer__qty-btn" data-qty-change="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="eride-cart-drawer__item-price">' + formatMoney(getLineDisplayMinor(item)) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="eride-cart-drawer__remove" data-remove-line aria-label="Remove item">×</button>';

    return li;
  }

  function updateBadge(count) {
    document.querySelectorAll('.bigcounter, .count-style').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.shopping-cart__total').forEach(function (el) {
      /* total updated separately via cartUpdateInfo */
    });
  }

  function renderCart(cart) {
    var root = getDrawer();
    if (!root) return;

    var itemsEl = root.querySelector('[data-eride-cart-items]');
    var emptyEl = root.querySelector('[data-eride-cart-empty]');
    var footerEl = root.querySelector('[data-eride-cart-footer]');
    var subtotalEl = root.querySelector('[data-eride-cart-subtotal]');
    var titleEl = root.querySelector('#eride-cart-drawer-title');

    if (!itemsEl) return;

    itemsEl.innerHTML = '';
    var hasItems = cart && cart.items && cart.items.length > 0;

    if (!hasItems) {
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      if (titleEl) titleEl.textContent = 'Your Cart';
      updateBadge(0);
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;
    if (titleEl) titleEl.textContent = 'Your Cart (' + cart.item_count + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(getCartSubtotalMinor(cart));

    cart.items.forEach(function (item) {
      itemsEl.appendChild(renderItem(item));
    });

    updateBadge(cart.item_count);

    if (typeof Shopify !== 'undefined' && Shopify.cartUpdateInfo) {
      Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return cart;
        var fixes = [];
        cart.items.forEach(function (item) {
          var minQty = getItemMinQty(item);
          if (item.quantity > 0 && item.quantity < minQty) {
            fixes.push(changeLine(item.key, minQty));
          }
        });
        if (!fixes.length) return cart;
        return Promise.all(fixes).then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        });
      });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart update failed');
      return r.json();
    });
  }

  function setLoading(on) {
    var root = getDrawer();
    if (!root) return;
    var loadingEl = root.querySelector('[data-eride-cart-loading]');
    var itemsEl = root.querySelector('[data-eride-cart-items]');
    var emptyEl = root.querySelector('[data-eride-cart-empty]');
    if (loadingEl) loadingEl.hidden = !on;
    if (on) {
      if (itemsEl) itemsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
    } else if (itemsEl) {
      itemsEl.hidden = false;
    }
  }

  function openDrawer() {
    var root = getDrawer();
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('eride-cart-open');
    fetchCart().then(renderCart).catch(function () {});
  }

  function closeDrawer() {
    var root = getDrawer();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('eride-cart-open');
  }

  function bindEvents() {
    var root = getDrawer();
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-eride-cart-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var removeBtn = e.target.closest('[data-remove-line]');
      if (removeBtn) {
        var itemEl = removeBtn.closest('[data-line-key]');
        if (!itemEl) return;
        removeBtn.disabled = true;
        changeLine(itemEl.dataset.lineKey, 0).then(renderCart).catch(function () {
          removeBtn.disabled = false;
        });
        return;
      }

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var row = qtyBtn.closest('[data-line-key]');
        if (!row) return;
        var display = row.querySelector('[data-qty-display]');
        var current = parseInt(display.textContent, 10) || 1;
        var delta = parseInt(qtyBtn.dataset.qtyChange, 10);
        var minQty = parseInt(row.dataset.minQty, 10) || 1;
        var next = current + delta;
        if (next > 0 && next < minQty) next = minQty;
        next = Math.max(0, Math.min(99, next));
        if (next === current) return;
        qtyBtn.disabled = true;
        changeLine(row.dataset.lineKey, next).then(renderCart).catch(function () {
          qtyBtn.disabled = false;
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.querySelectorAll('.icon-cart-active').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }, true);
    });

    document.querySelectorAll('.cart-close').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var wrap = btn.closest('.cart-wrap');
        if (wrap) wrap.classList.remove('show');
      });
    });
  }

  window.ErideCart = {
    open: openDrawer,
    close: closeDrawer,
    setLoading: setLoading,
    refresh: function () {
      return fetchCart().then(function (cart) {
        setLoading(false);
        renderCart(cart);
        return cart;
      }).catch(function (err) {
        setLoading(false);
        throw err;
      });
    },
    render: renderCart
  };

  if (typeof Shopify !== 'undefined') {
    Shopify.getCart = function (callback) {
      fetchCart().then(function (cart) {
        if (typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate(cart);
        if (typeof callback === 'function') callback(cart);
        renderCart(cart);
      });
    };

    Shopify.removeItem = function (lineKeyOrVariantId) {
      fetchCart().then(function (cart) {
        var line = cart.items.find(function (item) {
          return String(item.key) === String(lineKeyOrVariantId) ||
            String(item.variant_id) === String(lineKeyOrVariantId);
        });
        if (!line) return;
        changeLine(line.key, 0).then(renderCart);
      });
    };
  }

  function hookShopifyCart() {
    if (typeof Shopify === 'undefined') return;

    var origOnItemAdded = Shopify.onItemAdded;
    Shopify.onItemAdded = function (line_item) {
      if (typeof origOnItemAdded === 'function') origOnItemAdded(line_item);
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    };

    Shopify.cartPopapForm = function () {
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    };

    Shopify.cartPopap = function () {
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    };
  }

  hookShopifyCart();
  document.addEventListener('DOMContentLoaded', hookShopifyCart);

  function init() {
    loadConfig();
    bindEvents();
    fetchCart().then(renderCart).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
